import { Backdrop, CircularProgress } from '@mui/material';

const BackdropSpinner = () => (
    <Backdrop open>
        <CircularProgress color="primary" />
    </Backdrop>
);

export default BackdropSpinner;
